module.exports = __webpack_public_path__ + "static/hotspots-51bfde73c3f2eec2a11b88b05c248c50.jpg";